export default function Comparison() {
  const platforms = [
    {
      name: 'YOYBUY Spreadsheet',
      commission: 'Низкая',
      ux: 'Excel-подобный',
      transparency: 'Полная',
      support: 'Spreadsheet',
      rating: 5,
      highlight: true,
    },
    {
      name: 'Kakobuy',
      commission: 'Средняя',
      ux: 'Веб-панель',
      transparency: 'Частичная',
      support: 'Частично',
      rating: 3,
      highlight: false,
    },
    {
      name: 'Superbuy',
      commission: 'Средняя',
      ux: 'Веб-панель',
      transparency: 'Частичная',
      support: 'Частично',
      rating: 4,
      highlight: false,
    },
    {
      name: 'Другие агенты',
      commission: 'Высокая',
      ux: 'Ручной',
      transparency: 'Низкая',
      support: 'Нет',
      rating: 2,
      highlight: false,
    },
  ];

  return (
    <section id="compare" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-14">
          <span className="inline-flex items-center px-4 py-2 rounded-full border border-white/20 text-white/70 text-sm whitespace-nowrap w-fit">
            Сравнение платформ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight lg:w-2/3">
            YOYBUY Spreadsheet vs Kakobuy vs Superbuy
          </h2>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-6 snap-x snap-mandatory">
          {platforms.map((p) => (
            <div
              key={p.name}
              className={`flex-shrink-0 w-[280px] md:w-[300px] snap-start rounded-2xl overflow-hidden ${
                p.highlight ? 'bg-accent-500' : 'bg-background-100'
              }`}
            >
              <div className={`p-6 ${p.highlight ? 'text-foreground-950' : ''}`}>
                <div className="flex items-center gap-2 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm ${
                        i < p.rating
                          ? (p.highlight ? 'text-foreground-950' : 'text-primary-500')
                          : (p.highlight ? 'text-foreground-950/20' : 'text-foreground-200')
                      }`}
                    ></i>
                  ))}
                </div>
                <h3 className={`font-heading text-xl font-bold mb-5 ${p.highlight ? 'text-foreground-950' : 'text-foreground-950'}`}>
                  {p.name}
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className={`text-sm ${p.highlight ? 'text-foreground-950/60' : 'text-foreground-600'}`}>Комиссия</span>
                    <span className={`text-sm font-semibold ${p.highlight ? 'text-foreground-950' : 'text-foreground-900'}`}>{p.commission}</span>
                  </div>
                  <div className={`w-full h-px ${p.highlight ? 'bg-foreground-950/10' : 'bg-foreground-200'}`}></div>
                  <div className="flex justify-between items-center">
                    <span className={`text-sm ${p.highlight ? 'text-foreground-950/60' : 'text-foreground-600'}`}>Интерфейс</span>
                    <span className={`text-sm font-semibold ${p.highlight ? 'text-foreground-950' : 'text-foreground-900'}`}>{p.ux}</span>
                  </div>
                  <div className={`w-full h-px ${p.highlight ? 'bg-foreground-950/10' : 'bg-foreground-200'}`}></div>
                  <div className="flex justify-between items-center">
                    <span className={`text-sm ${p.highlight ? 'text-foreground-950/60' : 'text-foreground-600'}`}>Прозрачность</span>
                    <span className={`text-sm font-semibold ${p.highlight ? 'text-foreground-950' : 'text-foreground-900'}`}>{p.transparency}</span>
                  </div>
                  <div className={`w-full h-px ${p.highlight ? 'bg-foreground-950/10' : 'bg-foreground-200'}`}></div>
                  <div className="flex justify-between items-center">
                    <span className={`text-sm ${p.highlight ? 'text-foreground-950/60' : 'text-foreground-600'}`}>Spreadsheet</span>
                    <span className={`text-sm font-semibold ${p.highlight ? 'text-foreground-950' : 'text-foreground-900'}`}>{p.support}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}